/**
 * WHAT THIS SCREEN DOES NOT DRAW, SAID ON THE SCREEN - NOW IN ONE PLAIN LINE.
 *
 * The prototype's "Calendar & Ideas" page carries three panes with nothing behind them, and
 * `docs/ui/04-pages.md` §3.6 proves it rather than asserting it — the same python count over
 * both specs returns `saturation 0, theme 0, pitch 0, busy 0` for each file, re-verified:
 *
 *   • THE THEME CHIPS — open / getting busy / covered. No theme entity exists anywhere on this
 *     platform and no saturation number is on any wire. The only saturation-shaped field that exists
 *     at all is `CalendarEvent.linked_article_count`, which is ADMIN-ONLY and is not on the author's
 *     wire (`04-pages.md`).
 *   • "13 PIECES ALREADY IN MOTION · 4 THEMES OPEN." The same absence, stated as a number.
 *   • HEADLINE STARTERS. There is no title-suggestion route; `suggestTags` suggests tags only.
 *
 * `04-pages.md` §8 names "calendar theme saturation" as one of the THREE BIGGEST platform-side
 * gaps still needing an owner's decision, alongside per-article analytics and the whole comments
 * surface. A pane marked PLATFORM WORK OWED has no operation behind it: it is not drawn, not faked,
 * and given no invented endpoint.
 *
 * ★ WHY IT USED TO BE A LIST ON THE SCREEN, AND WHY IT IS NOW ONE LINE. It was written for an author
 * who had used the prototype and would look for the chips. On 2026-10-01 the owner, looking at real
 * cabinets, ruled the other way (design 15, decision 1): "leave out what nothing backs", and no
 * internal or technical words in front of an author - "its like a user for us". A list of features
 * that do not exist, worded in "wire" and "saturation figure", told an author how the platform works
 * inside. So the three panes are simply not drawn, and what stays on the screen is the one thing an
 * author reading the counts is owed: that other authors are counted and never named - the
 * prototype's own second line ("These are pieces from across the MoonX team … not a race"), told
 * truthfully for a calendar that shows counts. `web/ui/test/e2e/calendar-accessibility.spec.ts`
 * finds it by its role and these words.
 */
import { Text } from '@mantine/core';
import { useTranslation } from '../../../i18n';

export function NotDrawn() {
  const { t } = useTranslation('calendar');
  return (
    <Text size="sm" c="dimmed" role="note" maw={620} style={{ lineHeight: 1.6 }}>
      {t('notDrawn')}
    </Text>
  );
}
